/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RuoloInsertDto } from '../../models/ruolo-insert-dto';

export interface ApiAuthRuoloInsertPost$Params {
    /**
     * application/json
     */
    body: RuoloInsertDto;
}

export function apiAuthRuoloInsertPost(
    http: HttpClient,
    rootUrl: string,
    params: ApiAuthRuoloInsertPost$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(rootUrl, apiAuthRuoloInsertPost.PATH, 'post');
    if (params) {
        rb.body(params.body, 'application/json');
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return (r as HttpResponse<any>).clone({
                body: String((r as HttpResponse<any>).body) === 'true',
            }) as StrictHttpResponse<boolean>;
        }),
    );
}

apiAuthRuoloInsertPost.PATH = '/api/auth/ruolo-insert';
